

export enum SessionLecturerType {
  SUBSTITUTION = 'SUBSTITUTION',
  REGULAR = 'REGULAR'
};
